import { Divider, TextField } from '@material-ui/core';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Grid } from '../../../../components';
import { ALERT_TYPES, POINT_REGISTER_TYPE } from '../../../../utils/enums';
import { StyledGrid } from '../styles';

const PointAdjustInfo = ({ values, reasonLabel }) => {
  const { date, reason, justification, pointAlert, registerDate } = values;

  const alertTypeLabel = {
    [ALERT_TYPES.FAULT]: 'Falta',
    [ALERT_TYPES.PENDENT]: 'Pendência de ponto',
  };

  const pointTypeLabels = {
    [POINT_REGISTER_TYPE.BREAK_ENTRY]: 'Ida',
    [POINT_REGISTER_TYPE.BREAK_EXIT]: 'Volta',
    [POINT_REGISTER_TYPE.ENTRY]: 'Entrada',
    [POINT_REGISTER_TYPE.EXIT]: 'Saída',
    [POINT_REGISTER_TYPE.MAIN_BREAK_ENTRY]: 'Intervalo principal - Ida',
    [POINT_REGISTER_TYPE.MAIN_BREAK_EXIT]: 'Intervalo principal - Volta',
  };

  const labelPoint = useMemo(() => {
    let description = 'Nenhum registro de ponto';

    if (pointAlert.alertType === ALERT_TYPES.PENDENT && pointAlert.breakName) {
      description = `${pointAlert.breakName} - ${
        pointTypeLabels[pointAlert.pointType]
      }`;
    } else if (
      pointAlert.alertType === ALERT_TYPES.PENDENT &&
      !pointAlert.breakName
    ) {
      description = pointTypeLabels[pointAlert.pointType];
    }

    return description;
  }, [
    pointAlert.alertType,
    pointAlert.breakName,
    pointAlert.pointType,
    pointTypeLabels,
  ]);

  return (
    <>
      <StyledGrid item xs={6}>
        <TextField
          name="date"
          label="Data da solicitação"
          variant="filled"
          value={date}
          disabled
          fullWidth
        />
      </StyledGrid>
      <StyledGrid item xs={6}>
        <TextField
          name="alert"
          label="Alerta"
          variant="filled"
          value={alertTypeLabel[pointAlert.alertType]}
          disabled
          fullWidth
        />
      </StyledGrid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <StyledGrid item xs={6}>
        <TextField
          name="point"
          label="Ponto"
          variant="filled"
          value={labelPoint}
          disabled
          fullWidth
        />
      </StyledGrid>
      <StyledGrid item xs={6}>
        <TextField
          name="reason"
          label="Motivo"
          variant="filled"
          value={reasonLabel[reason]}
          disabled
          fullWidth
        />
      </StyledGrid>
      {registerDate ? (
        <StyledGrid item xs={6}>
          <TextField
            name="registerDate"
            label="Data e horário a ser registrado"
            variant="filled"
            value={format(new Date(registerDate), 'dd/MM/yyyy HH:mm')}
            disabled
            fullWidth
          />
        </StyledGrid>
      ) : (
        <StyledGrid item xs={12}>
          <TextField
            name="pointStartDate"
            label="Data que será ajustada"
            variant="filled"
            disabled
            value={format(new Date(pointAlert.pointStartDate), 'dd/MM/yyyy ')}
            fullWidth
          />
        </StyledGrid>
      )}
      <StyledGrid item xs={12}>
        <TextField
          name="justification"
          label="Justificativa"
          variant="filled"
          disabled
          value={justification}
          fullWidth
        />
      </StyledGrid>
    </>
  );
};

PointAdjustInfo.propTypes = {
  values: PropTypes.objectOf(PropTypes.any).isRequired,
  reasonLabel: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default PointAdjustInfo;
